import * as React from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

export default function SearchBar({
  width,
  onSearch,
  sWidth,
  height,
  searchTerm = '',
  onClear,
  placeholder = 'Search',
}) {
  return (
    <Paper
      component='form'
      onSubmit={(e) => {
        e.preventDefault();
      }}
      sx={{
        height: height || '2.5rem',
        display: 'flex',
        alignItems: 'center',
        width: sWidth || {},
        boxShadow: 'none',
        border: '1px solid #DFDFDF',
        borderRadius: '7px',
        '&:hover': {
          borderColor: 'primary.main',
        },
        '&:active': {
          borderColor: 'primary.main',
        },
        '&:focus': {
          borderColor: 'primary.main',
        },
      }}
    >
      <IconButton
        type='button'
        sx={{ p: '10px' }}
        aria-label='search'
      >
        <SearchIcon />
      </IconButton>
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        value={searchTerm ?? ''}
        onChange={(e) => onSearch(e.target.value)}
      />
      {Boolean(searchTerm) && (
        <IconButton
          type='button'
          size='small'
          sx={{ p: '8px', mr: '4px' }}
          aria-label='clear search'
          onClick={() => {
            if (typeof onClear === 'function') {
              onClear();
            } else if (typeof onSearch === 'function') {
              onSearch('');
            }
          }}
        >
          <ClearIcon fontSize='small' />
        </IconButton>
      )}
    </Paper>
  );
}
